import React from "react";

const ThumbsDown = ({ color = "var(--icon-button-fill)", opacity = "var(--icon-button-opacity)" }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity={opacity}>
      <rect
        x="11.272"
        y="26.0527"
        width="10.4936"
        height="20.9872"
        rx="2.09872"
        transform="rotate(178.195 11.272 26.0527)"
        fill={color}
      />
      <path
        d="M25.9442 24.51C25.578 24.1709 25.0985 24.7471 26.1099 29.7655C27.3741 36.0386 25.3094 38.2079 22.1131 38.3087C18.9167 38.4094 19.7834 32.0692 17.5531 28.9831C16.8533 28.0147 12.7926 24.5738 10.9616 22.878C8.03856 20.3709 3.64104 13.9434 9.43533 8.29019C15.2296 2.63694 22.4103 2.62076 25.2764 3.31933M25.9442 24.51C30.2599 26.0859 35.6057 25.8576 36.3313 23.7731C37.0568 21.6887 35.8089 20.6583 34.3355 20.037M25.9442 24.51C17.1156 21.2864 19.707 17.7688 22.4995 17.6808M34.3355 20.037C32.862 19.4157 33.5433 19.2288 28.3545 18.1212C27.2037 17.8756 23.8261 17.639 22.4995 17.6808M34.3355 20.037C37.3265 19.9427 39.8792 16.6094 36.287 14.2822M22.4995 17.6808C21.9684 17.089 21.6629 17.164 21.4307 16.6596C21.1828 16.1209 21.094 15.6319 21.14 15.1922M24.5012 12.5626C27.536 11.8479 31.9978 12.2399 35.202 13.6968C35.6159 13.885 35.976 14.0807 36.287 14.2822M24.5012 12.5626C23.9935 11.287 23.7968 9.15259 25.4171 7.78648M24.5012 12.5626C22.6129 13.0073 21.2769 13.8805 21.14 15.1922M36.287 14.2822C38.9587 11.1851 38.5048 8.73346 35.8171 7.4587M25.4171 7.78648C26.2614 7.07466 27.599 6.57145 29.6429 6.50703C32.2595 6.42456 34.3645 6.76975 35.8171 7.4587M25.4171 7.78648C24.0715 6.92169 22.5503 5.0078 25.2764 3.31933M35.8171 7.4587C37.5639 3.2892 34.1633 0.0516972 27.3794 2.36979C26.4964 2.67155 25.8061 2.99118 25.2764 3.31933M21.14 15.1922C20.3508 14.5779 18.2912 13.6616 16.3659 14.91"
        stroke={color}
        strokeWidth="2.06055"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default ThumbsDown;
